var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbroad03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_12",
    "data-name": 12,
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.028,
    height: 105.167,
    viewBox: "0 0 97.028 105.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2588",
    "data-name": "Group 2588",
    transform: "translate(8.929 6.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2587",
    "data-name": "Group 2587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4215",
    "data-name": "Path 4215",
    d: "M148.789,270.666v86.826h70.36V270.666Z",
    transform: "translate(-148.789 -270.666)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2586",
    "data-name": "Group 2586",
    transform: "translate(4.411 7.874)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_966",
    "data-name": "Rectangle 966",
    width: 59.788,
    height: 2.943,
    transform: "translate(0 25.573)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_967",
    "data-name": "Rectangle 967",
    width: 56.282,
    height: 2.943,
    transform: "translate(0 17.048)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_968",
    "data-name": "Rectangle 968",
    width: 59.788,
    height: 2.942,
    transform: "translate(0 8.525)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 52.062,
    height: 2.943,
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 56.282,
    height: 2.943,
    transform: "translate(0 34.067)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 59.788,
    height: 2.943,
    transform: "translate(0 42.562)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_972",
    "data-name": "Rectangle 972",
    width: 54.502,
    height: 2.943,
    transform: "translate(0 51.056)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 59.788,
    height: 2.943,
    transform: "translate(0 59.55)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 59.788,
    height: 2.943,
    transform: "translate(0 68.044)",
    fill: "#bcbec0"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2591",
    "data-name": "Group 2591",
    transform: "translate(8.985 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2590",
    "data-name": "Group 2590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4216",
    "data-name": "Path 4216",
    d: "M168.293,267.472l-19.476,84.614,68.567,15.781,10.522-45.71,8.954-38.9Z",
    transform: "translate(-148.817 -267.472)",
    fill: "#eff1f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2589",
    "data-name": "Group 2589",
    transform: "translate(6.085 8.661)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 2.944,
    height: 59.788,
    transform: "translate(9.527 27.789) rotate(-77.035)",
    fill: "#dadcde"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 2.943,
    height: 56.282,
    transform: "translate(11.437 19.492) rotate(-77.053)",
    fill: "#dadcde"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 2.943,
    height: 59.789,
    transform: "matrix(0.224, -0.974, 0.974, 0.224, 13.351, 11.173)",
    fill: "#dadcde"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 2.943,
    height: 52.062,
    transform: "matrix(0.224, -0.975, 0.975, 0.224, 15.263, 2.868)",
    fill: "#dadcde"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 2.943,
    height: 56.283,
    transform: "matrix(0.224, -0.975, 0.975, 0.224, 7.621, 36.068)",
    fill: "#dadcde"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 2.943,
    height: 59.789,
    transform: "translate(5.716 44.347) rotate(-77.037)",
    fill: "#dadcde"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 2.942,
    height: 54.503,
    transform: "translate(3.81 52.624) rotate(-77.038)",
    fill: "#dadcde"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 2.943,
    height: 59.788,
    transform: "translate(1.905 60.902) rotate(-77.038)",
    fill: "#dadcde"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 2.942,
    height: 59.788,
    transform: "translate(0 69.181) rotate(-77.039)",
    fill: "#dadcde"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2592",
    "data-name": "Group 2592",
    transform: "translate(0 48.132)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_984",
    "data-name": "Rectangle 984",
    width: 92.875,
    height: 57.035,
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4217",
    "data-name": "Path 4217",
    d: "M190.686,333.227l-46.438-41.275h92.875Z",
    transform: "translate(-144.247 -291.952)",
    fill: "#c5911d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    "data-name": "Path 4218",
    d: "M190.686,327.2l-46.438-35.246h92.875Z",
    transform: "translate(-144.247 -291.952)",
    fill: "#f9b316"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbroad03);
export default __webpack_public_path__ + "static/media/abroad-03.23029d85df6e8f4e063577bc8ff1b43f.svg";
export { ForwardRef as ReactComponent };